<section class="about-banner">
    <div class="container">       
      <div class="row d-flex align-items-center justify-content-center">
        <div class="about-content col-lg-12 mt-5">
          <h1 class="text-white">
            Career        
          </h1> 
          <p class="text-white link-nav"><a routerLink="/">Home</a><span class="lnr lnr-arrow-right"></span>
            <a routerLink="/carrier">Career</a>
          </p>
          <h4 class="site-banner">
            Here you will know about my Career, Experience,  Researches and more below.
          </h4>
        </div>  
      </div>
    </div>
  </section>
  
  <section class="job-area offwhite pt-3 section-gap-bottom-90">
   <div class="container">
    <div class="row d-flex">
      <div class="col-lg-12">
        <div class="section-title ">
          <h1>My Experience</h1>
        </div>
      </div>
    </div>
  
    <div class="row">
      <div class="col-lg-6">
        <div class="single-job">
          <div class="top-sec d-flex justify-content-between ">
            <div class="top-left prosan">
              <h4>Wisflux Edtech Labs</h4>
              <p>IT, Jaipur</p>
            </div>
            <div class="top-right">
              <a routerLink="#" class="primary-btn" data-text="May`19 to June`19">
                <span>M</span><span>a</span><span>y</span>
                <span>'</span><span>1</span><span>9</span>
                <span>t</span><span>o</span>
                <span>J</span><span>u</span><span>n</span><span>e</span><span>'</span><span>1</span><span>9</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="single-job">
          <div class="top-sec d-flex justify-content-between">
            <div class="top-left prosan">
              <h4>Rayqube Future Tech. Pvt Ltd</h4>
              <p>Future Technology, Jaipur</p>
            </div>
            <div class="top-right ">
              <a routerLink="#" class="primary-btn" data-text="August'18 to Dec.`18">
                <span>A</span><span>u</span><span>g</span>
                <span>'</span><span>1</span><span>8</span>
                <span>t</span><span>o</span>
                <span>D</span><span>e</span><span>c</span><span>.</span><span>'</span><span>1</span><span>8</span>
              </a>
            </div>
          </div>
        </div>
      </div>
  
      <div class="col-lg-6">
        <div class="single-job">
          <div class="top-sec d-flex justify-content-between">
            <div class="top-left prosan">
              <h4>DXB</h4>
              <p>IT, Kota</p>
            </div>
            <div class="top-right">
              <a routerLink="#" class="primary-btn" data-text="June'18 to July`18">
                <span>J</span><span>u</span><span>n</span><span>e</span>
                <span>'</span><span>1</span><span>8</span>
                <span>t</span><span>o</span>
                <span>J</span><span>u</span><span>l</span><span>y</span><span>'</span><span>1</span><span>8</span>
              </a>
            </div>
          </div>
        </div>
      </div>
  
  
  
    </div>
  </div>
  </section>
  
  <section class="job-area offwhite pt-3 topic_head section-gap-bottom-90">
    <div class="container">
      <div class="row d-flex">
        <div class="col-lg-12">
          <div class="section-title">
            <h1 class="section-title">Academic Career</h1>
            <p class="prosan"><strong>Secondary Education Qualification</strong>  St Joseph`s Senior Secondary School - 8.0 CGPA 2014</p>
            <p class="prosan"><strong>Senior Secondary Education Qualification</strong>  Sarvodaya Public School - 68.6% 2016</p>
          </div>
          <br>
          <div class="section-title">
            <h1 class="section-title">Research and Publication</h1>
            <strong>International Conference on Information Technology and Digital Applications proceeding (Published): Nurul Hassan, Nishchay Jain & Dr. Vinay Kumar Chandna. (2018). Review on BLOCKCHAIN, CRYPTOCURRENCY, AND BITCOIN. In International Journal of Computer Engineering and Applications (Publication), Volume XII, Special Issue, April - ICITDA 18.</strong>
          </div> 
        </div>
      </div> 
    </div>
  </section>